import Class from './c-date-picker-test';
import './c-date-picker-test.scss';
import './c-date-picker-test@';

export default Class;